module.exports = __webpack_public_path__ + "img/contest.edf71857.png";